var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpritesheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-area"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.346 18.955c-.576.33-.596.545-.596.545 0 .003 0 .032.04.093.044.068.13.163.284.277.312.23.81.468 1.493.682 1.357.424 3.278.698 5.433.698s4.076-.274 5.433-.698c.683-.214 1.181-.452 1.493-.682.153-.114.24-.21.284-.277.04-.061.04-.09.04-.093 0 0-.02-.215-.596-.545-.526-.302-1.331-.584-2.363-.8l1.248-1.14c1.094.29 1.115.278 1.86.638.665.38 1.351.981 1.351 1.847 0 .695-.45 1.219-.933 1.576-.498.369-1.172.669-1.936.908-1.539.48-3.618.766-5.881.766-2.263 0-4.342-.286-5.88-.766-.765-.24-1.439-.54-1.937-.908-.484-.357-.933-.881-.933-1.576 0-.866.686-1.466 1.351-1.847.666-.381.58-.3 1.712-.637l1.396 1.14c-1.032.215-1.836.497-2.363.799z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18.814 9.035C18.814 14.663 12 19 12 19s-7-4.337-7-9.965C5 5.15 8.092 2 11.907 2s6.907 3.15 6.907 7.035z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M14.21 8.907a2.302 2.302 0 1 1-4.605 0 2.302 2.302 0 0 1 4.604 0z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M18 15l-6 5-6-5m6 5V4"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-area-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.346 18.955c-.576.33-.596.545-.596.545 0 .003 0 .032.04.093.044.068.13.163.284.277.312.23.81.468 1.493.682 1.357.424 3.278.698 5.433.698s4.076-.274 5.433-.698c.683-.214 1.181-.452 1.493-.682.153-.114.24-.21.284-.277.04-.061.04-.09.04-.093 0 0-.02-.215-.596-.545-.526-.302-1.331-.584-2.363-.8l1.248-1.14c1.094.29 1.115.278 1.86.638.665.38 1.351.981 1.351 1.847 0 .695-.45 1.219-.933 1.576-.498.369-1.172.669-1.936.908-1.539.48-3.618.766-5.881.766-2.263 0-4.342-.286-5.88-.766-.765-.24-1.439-.54-1.937-.908-.484-.357-.933-.881-.933-1.576 0-.866.686-1.466 1.351-1.847.666-.381.58-.3 1.712-.637l1.396 1.14c-1.032.215-1.836.497-2.363.799z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 19l-.396.637L12 19zm-.396.637l.401.249.398-.253L12 19c.403.633.404.632.404.632l.001-.001.006-.003.017-.012a8.292 8.292 0 0 0 .293-.198 21.965 21.965 0 0 0 3.229-2.773c1.744-1.83 3.614-4.502 3.614-7.61 0-4.287-3.415-7.785-7.657-7.785S4.25 4.748 4.25 9.035c0 3.115 1.925 5.79 3.714 7.617a22.344 22.344 0 0 0 3.315 2.772 13.958 13.958 0 0 0 .3.197l.018.012.005.003.002.001zm-1.25-10.73a1.552 1.552 0 1 1 3.105 0 1.552 1.552 0 0 1-3.104 0zm1.553-3.052a3.052 3.052 0 1 0 0 6.104 3.052 3.052 0 0 0 0-6.104z",
    clipRule: "evenodd"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-extreme"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C60000",
    fillRule: "evenodd",
    d: "M11.53 3l-.941 12.857L7 15l5.001 6L17 15l-3.587.857L12.471 3h-.941z",
    clipRule: "evenodd"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-outline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#fff",
    d: "M11.53 2.5h-.465l-.034.463-.898 12.271-3.017-.72-1.464-.35.964 1.156 5 6 .385.461.384-.46 5-6 .962-1.157-1.463.35-3.015.72-.9-12.27-.033-.464H11.53z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M6 9l6-5 6 5m-6-5v16"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M15 6l5 6-5 6m5-6H4"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-book"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M4 9h2m8 0h2M4 12h6m4 0h6M4 15h6m4 0h6m2-9v12a1 1 0 0 1-1 1h-5.111a8 8 0 0 0-3.578.845L12 20l-.31-.155A8 8 0 0 0 8.11 19H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5.111a8 8 0 0 1 3.578.845L12 6l.31-.155A8 8 0 0 1 15.89 5H21a1 1 0 0 1 1 1zM12 6v14"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M9 18l-5-6 5-6m-5 6h16"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.53 3l-.941 12.857L7 15l5.001 6L17 15l-3.587.857L12.471 3h-.941z",
    clipRule: "evenodd"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bathing-spot"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16.762 7.85c0 3.88-4.762 6.525-4.762 6.525S7.238 11.73 7.238 7.85C7.238 5.17 9.37 3 12 3c2.63 0 4.762 2.171 4.762 4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M13.587 7.762a1.587 1.587 0 1 1-3.174 0 1.587 1.587 0 0 1 3.174 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 18c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1M3 15c1 0 3-1 3-1s2 1 3 1m6 0c1 0 3-1 3-1s2 1 3 1M3 21c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-bell"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12 2a7 7 0 0 0-7 7v4c0 1.105 0 1.5-1 2-.988.494-2 .895-2 2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2c0-1.105-1.012-1.506-2-2-1-.5-1-.895-1-2V9a7 7 0 0 0-7-7zm-2 19a2 2 0 1 0 4 0"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 8l9 8 9-8"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M16 21l-8-9 8-9"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-check"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M4 12l6 6.5L21 6"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M8 21l8-9-8-9"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-calendar"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 8.25a.75.75 0 0 0 0 1.5v-1.5zm20 1.5a.75.75 0 0 0 0-1.5v1.5zm-19-5h18v-1.5H3v1.5zM21.25 5v16h1.5V5h-1.5zM2.75 21V5h-1.5v16h1.5zm.25.25a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5zM21.25 21a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 22.75 21h-1.5zM21 4.75a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 21 3.25v1.5zM3 3.25A1.75 1.75 0 0 0 1.25 5h1.5A.25.25 0 0 1 3 4.75v-1.5zM18.75 5.5V1h-1.5v4.5h1.5zm-12 0V1h-1.5v4.5h1.5zM2 9.75h10v-1.5H2v1.5zm10 0h10v-1.5H12v1.5zm9 11.5h-9v1.5h9v-1.5zm-9 0H3v1.5h9v-1.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 13,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 17,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 13,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 1,
    fill: "currentColor"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-top"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 18l9-8 9 8M3 7h18"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-cross"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M4 20L20 4M4 4l16 16"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dots-vertical"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 6zm0 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 12zm0 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 18z",
    clipRule: "evenodd"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-clock"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M12 6.5V12l2.5 2.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-collapse"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M21 9h-5a1 1 0 0 1-1-1V3m0 18v-5a1 1 0 0 1 1-1h5M4 15h5a1 1 0 0 1 1 1v5m0-18v5a1 1 0 0 1-1 1H4"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dots-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 10a2 2 0 1 1-.001 4.001A2 2 0 0 1 6 10zm6 0a2 2 0 1 1-.001 4.001A2 2 0 0 1 12 10zm6 0a2 2 0 1 1-.001 4.001A2 2 0 0 1 18 10z",
    clipRule: "evenodd"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dots"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 6zm0 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 12zm0 6a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 18z",
    clipRule: "evenodd"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drop-empty"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.837 13.186C3.837 6.535 12 2 12 2s8.163 4.535 8.163 11.186c0 4.592-3.655 8.314-8.163 8.314-4.508 0-8.163-3.722-8.163-8.314z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drop-full"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.837 13.186C3.837 6.535 12 2 12 2s8.163 4.535 8.163 11.186c0 4.592-3.655 8.314-8.163 8.314-4.508 0-8.163-3.722-8.163-8.314z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drop-light"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.837 13.186C3.837 6.535 12 2 12 2s8.163 4.535 8.163 11.186c0 4.592-3.655 8.314-8.163 8.314-4.508 0-8.163-3.722-8.163-8.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21.5c3.362 0 6.25-2.07 7.5-5.027h-15C5.75 19.43 8.638 21.5 12 21.5z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-dustbin"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M6 7v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7M4 6h16m-4-.5l-.749-1.871A1 1 0 0 0 14.323 3H9.677a1 1 0 0 0-.928.629L8 5.5m6 5.5v5m-4-5v5"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-down"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 9l9 5 9-5"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-drop-medium"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3.837 13.186C3.837 6.535 12 2 12 2s8.163 4.535 8.163 11.186c0 4.592-3.655 8.314-8.163 8.314-4.508 0-8.163-3.722-8.163-8.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 21c4.418 0 8-3 8-9.5H4C4 18 7.582 21 12 21z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12 6v7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 16l9-8 9 8"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-file-pdf"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M21 8h-5a1 1 0 0 1-1-1V2M3 21V3c0-.552.403-1 .9-1H16l5 5v14c0 .552-.403 1-.9 1H3.9c-.497 0-.9-.448-.9-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.967 14.416c.83-3.353-14.113 1.112-11.704 3.353 2.41 2.24 7.229-12.573 3.787-11.735-3.443.838 7.087 11.735 7.917 8.382z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M19.425 4.075a3 3 0 0 0-4.243 0l-9.9 9.9L4 19.5l5.525-1.282 9.9-9.9a3 3 0 0 0 0-4.243zm-4.95.707l4.243 4.243m-2.122-2.121l-7.778 7.778"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10 18l-1.182-3.318L5.5 13.5"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M7 12h10m-7 6h4M3 6h18"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-expand"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10 20H5a1 1 0 0 1-1-1v-5m0-4V5a1 1 0 0 1 1-1h5m4 0h5a1 1 0 0 1 1 1v5m0 4v5a1 1 0 0 1-1 1h-5"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-geolocation-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.948 11.075L17.92 5.087c.845-.39 1.717.483 1.327 1.327L13.26 19.387c-.412.893-1.732.716-1.894-.255l-.763-4.578a1 1 0 0 0-.822-.822l-4.578-.763c-.971-.162-1.149-1.482-.255-1.894z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-globe"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.25 12A9.25 9.25 0 0 1 12 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75h-1.5zM12 21.25A9.25 9.25 0 0 1 2.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75v-1.5zM2.75 12A9.25 9.25 0 0 1 12 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12h1.5zM12 2.75A9.25 9.25 0 0 1 21.25 12h1.5c0-5.937-4.813-10.75-10.75-10.75v1.5zm-2.58-.83C8.487 3.057 6.685 6.29 6.685 12h1.5c0-5.395 1.701-8.283 2.395-9.131l-1.162-.95zM6.685 12c0 5.721 1.84 8.917 2.719 10.062l1.19-.912c-.683-.891-2.41-3.767-2.41-9.15h-1.5zm6.719-9.15c.693.904 2.513 3.782 2.513 9.15h1.5c0-5.736-1.954-8.93-2.823-10.062l-1.19.912zM15.918 12c0 5.368-1.82 8.246-2.513 9.15l1.19.912c.869-1.133 2.823-4.326 2.823-10.062h-1.5zM2 12.75h20v-1.5H2v1.5zm1-5h18v-1.5H3v1.5zm0 10h18v-1.5H3v1.5z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-graph"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M2 12s1-7 5-7c5 0 5 14 10 14 4 0 5-7 5-7"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-list-search"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 10h7m-7 8h7m-7-4h6M3 6h13.888"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M19 17l2.121 2.121"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-house"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.5,
    d: "M5 10v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V10M3 11l8.386-6.522a1 1 0 0 1 1.228 0L21 11m-7 10v-6a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v6"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-geolocation"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4.948 11.074L17.92 5.087c.845-.39 1.717.483 1.327 1.327L13.26 19.387c-.412.893-1.732.716-1.894-.255l-.763-4.578a1 1 0 0 0-.822-.822l-4.578-.763c-.971-.162-1.149-1.482-.255-1.895z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-help"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.25 12A9.25 9.25 0 0 1 12 21.25v1.5c5.937 0 10.75-4.813 10.75-10.75h-1.5zM12 21.25A9.25 9.25 0 0 1 2.75 12h-1.5c0 5.937 4.813 10.75 10.75 10.75v-1.5zM2.75 12A9.25 9.25 0 0 1 12 2.75v-1.5C6.063 1.25 1.25 6.063 1.25 12h1.5zM12 2.75A9.25 9.25 0 0 1 21.25 12h1.5c0-5.937-4.813-10.75-10.75-10.75v1.5zM16.25 12A4.25 4.25 0 0 1 12 16.25v1.5A5.75 5.75 0 0 0 17.75 12h-1.5zM12 16.25A4.25 4.25 0 0 1 7.75 12h-1.5A5.75 5.75 0 0 0 12 17.75v-1.5zM7.75 12A4.25 4.25 0 0 1 12 7.75v-1.5A5.75 5.75 0 0 0 6.25 12h1.5zM12 7.75A4.25 4.25 0 0 1 16.25 12h1.5A5.75 5.75 0 0 0 12 6.25v1.5zM6.35 3.715l2.5 4.33 1.3-.75-2.5-4.33-1.3.75zm7.5 12.99l2.5 4.33 1.3-.75-2.5-4.33-1.3.75zM2 12.75h5v-1.5H2v1.5zm15 0h5v-1.5h-5v1.5zm-9.35 8.285l2.5-4.33-1.3-.75-2.5 4.33 1.3.75zm7.5-12.99l2.5-4.33-1.3-.75-2.5 4.33 1.3.75z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location-color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D00",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M20.163 10.314C20.163 16.965 12 21.5 12 21.5s-8.163-4.535-8.163-11.186C3.837 5.722 7.492 2 12 2c4.508 0 8.163 3.722 8.163 8.314z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3,
    fill: "#fff"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-left"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M14 3l-5 9 5 9"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-info"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.72 16.397a.906.906 0 0 0-.015.175c0 .233.082.35.248.35.087 0 .184-.03.29-.088.108-.058.244-.155.409-.291l.19.452c-.166.223-.414.447-.744.67-.32.223-.714.335-1.18.335-.379 0-.675-.073-.889-.218a.736.736 0 0 1-.32-.627l.014-.146c.059-.505.258-1.972.598-4.4l.233-1.69-.86-.408.102-.568 2.506-.35.35.16-.933 6.644zm.16-8.203a.937.937 0 0 1-.685-.291 1.013 1.013 0 0 1-.277-.7c0-.359.117-.66.35-.903.243-.243.548-.364.918-.364.3 0 .539.097.714.291a.94.94 0 0 1 .262.67c0 .37-.112.68-.335.933-.224.243-.54.364-.947.364z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-list"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 10h18M3 14h18M3 18h18M3 6h18"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location-target"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.25 12A6.25 6.25 0 0 1 12 18.25v1.5A7.75 7.75 0 0 0 19.75 12h-1.5zM12 18.25A6.25 6.25 0 0 1 5.75 12h-1.5A7.75 7.75 0 0 0 12 19.75v-1.5zM5.75 12A6.25 6.25 0 0 1 12 5.75v-1.5A7.75 7.75 0 0 0 4.25 12h1.5zM12 5.75A6.25 6.25 0 0 1 18.25 12h1.5A7.75 7.75 0 0 0 12 4.25v1.5zM14.25 12A2.25 2.25 0 0 1 12 14.25v1.5A3.75 3.75 0 0 0 15.75 12h-1.5zM12 14.25A2.25 2.25 0 0 1 9.75 12h-1.5A3.75 3.75 0 0 0 12 15.75v-1.5zM9.75 12A2.25 2.25 0 0 1 12 9.75v-1.5A3.75 3.75 0 0 0 8.25 12h1.5zM12 9.75A2.25 2.25 0 0 1 14.25 12h1.5A3.75 3.75 0 0 0 12 8.25v1.5zm7 3h3v-1.5h-3v1.5zm-17 0h3v-1.5H2v1.5zM12.75 5V2h-1.5v3h1.5zm0 17v-3h-1.5v3h1.5z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.635 22.155L12 21.5l.364.656-.364.202-.365-.203zm0 0L12 21.5c.364.656.365.655.365.655l.002-.001.006-.003.021-.012.075-.043a21.297 21.297 0 0 0 1.233-.791 23.49 23.49 0 0 0 2.9-2.364c2.09-2.012 4.31-4.994 4.31-8.627 0-4.993-3.977-9.064-8.912-9.064-4.935 0-8.913 4.071-8.913 9.064 0 3.633 2.221 6.615 4.311 8.627a23.49 23.49 0 0 0 3.859 2.99 14.935 14.935 0 0 0 .349.208l.02.012.007.003.002.001zM10.03 10.163a1.97 1.97 0 1 1 3.942 0 1.97 1.97 0 0 1-3.942 0zM12 6.692a3.47 3.47 0 1 0 0 6.942 3.47 3.47 0 0 0 0-6.942z",
    clipRule: "evenodd"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.216 20c7.458 0 11.537-6.156 11.537-11.495 0-.175 0-.349-.011-.522a8.233 8.233 0 0 0 2.023-2.091c-.74.327-1.526.54-2.33.635a4.057 4.057 0 0 0 1.783-2.234 8.145 8.145 0 0 1-2.575.98 4.07 4.07 0 0 0-4.872-.794 4.038 4.038 0 0 0-2.038 4.48 11.527 11.527 0 0 1-8.357-4.222A4.034 4.034 0 0 0 4.63 10.13a4.036 4.036 0 0 1-1.84-.506v.052a4.045 4.045 0 0 0 3.253 3.96 4.063 4.063 0 0 1-1.831.07A4.058 4.058 0 0 0 8 16.51a8.156 8.156 0 0 1-6 1.675 11.51 11.51 0 0 0 6.216 1.812"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-map"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 6l18.5 3.5m-12.11-2l-3 13.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.347,
    d: "M17.441 13.667c0 1.192-.756 2.31-1.636 3.19a10.36 10.36 0 0 1-1.357 1.136 10.352 10.352 0 0 1-1.357-1.136c-.88-.88-1.636-1.998-1.636-3.19a2.993 2.993 0 1 1 5.986 0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 1,
    fill: "currentColor"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minus"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12h18"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-logo-yr"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.185 15.914s-.473.132-.826-.246c-.415-.444-1.071-1.338-1.071-1.338a3.427 3.427 0 0 0 1.514-.876c.664-.661 1.026-1.597 1.022-2.604.01-1.047-.45-1.988-1.176-2.578-.723-.597-1.655-.874-2.625-.875h-1.709a2.914 2.914 0 0 0-2.908 2.908v7.176h1.938v-2.036a.982.982 0 0 1 .97-.969h.772l2.085 2.554.146.18c.158.151.365.25.596.27v.001h.042a.282.282 0 0 0 .08 0h1.147l.003-1.567zM8.759 17.781c.797-.445 2.38-1.33 2.389-3.717V7.709H9.231l-.002 3.133c-.036 1.168-1.13 1.546-2.001 1.558-.995-.014-2.044-.566-2.044-2.083V7.709H3.293v2.608c0 1.184.409 2.195 1.184 2.925.701.66 1.662 1.031 2.712 1.049h.078c.705-.013 1.741-.473 1.942-.879v.863c0 1.144-1.455 1.89-1.847 2.086l.028.034a.477.477 0 0 0-.01.005l-.018.009 1.218 1.473.18-.101zm8.263-8.445c.605 0 1.09.177 1.39.428.295.257.464.558.474 1.085-.003.567-.184.96-.454 1.234-.275.271-.667.452-1.234.454h-1.885c-.292.001-.573.103-.839.2l-.13.047v-2.479a.982.982 0 0 1 .97-.969h1.708zM12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12z",
    clipRule: "evenodd"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-map-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.25 4c0-.966.784-1.75 1.75-1.75h16c.966 0 1.75.784 1.75 1.75v4.79L2.25 5.1V4zm7.777 4.096L21.75 10.32V20A1.75 1.75 0 0 1 20 21.75H7l3.027-13.654zm-1.475-.28L2.25 6.62V20c0 .966.784 1.75 1.75 1.75h1.46L8.552 7.816zm6.777 8.565c.843-.843 1.439-1.796 1.439-2.714a2.32 2.32 0 1 0-4.64 0c0 .918.596 1.871 1.439 2.714.306.306.616.568.88.774.266-.206.575-.468.882-.774zm-.881 2.419s3.667-2.2 3.667-5.133a3.667 3.667 0 1 0-7.334 0c0 2.933 3.667 5.133 3.667 5.133zm.052-4.3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    clipRule: "evenodd"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-new-window"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M10 4H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-5m1-4V3h-7m6.5.5L12 12"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-location"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M20.163 10.314C20.163 16.965 12 21.5 12 21.5s-8.163-4.535-8.163-11.186C3.837 5.722 7.492 2 12 2c4.508 0 8.163 3.722 8.163 8.314z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-offline"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M22 5a18.074 18.074 0 0 0-10-3A18.074 18.074 0 0 0 2 5m18 4c-2.28-1.893-5.034-3-8-3S6.28 7.107 4 9m14 3c-1.719-1.264-3.781-2-6-2-2.218 0-4.281.736-6 2m2.464 9.535l7.072-7.07m0 7.07l-7.071-7.07"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-mountain"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.913 7.152l-.651-.372.651.372zM2 21l-.651-.372-.641 1.122H2V21zm8.087-13.848l-.651.372.65-.372zM9 13.5l-.45.6.52.39.46-.46L9 13.5zm1.5-1.5l.335-.67-.483-.243-.382.383.53.53zm5.5 3v-.75h-.31l-.22.22.53.53zm6 6v.75h1.263l-.605-1.11L22 21zm-5.912-10.84l-.659.36.659-.36zm-.176 0l.659.36-.659-.36zm-2.57 3.147a.75.75 0 1 0 1.316.719l-1.316-.719zM9.262 6.78L1.349 20.628l1.302.744 7.913-13.848-1.302-.744zm9.39 13.848L10.737 6.78l-1.302.744 7.913 13.848 1.302-.744zM18 20.25H2v1.5h16v-1.5zM10.564 7.524a.65.65 0 0 1-1.128 0l1.302-.744a.85.85 0 0 0-1.476 0l1.302.744zM6.55 12.6l2 1.5.9-1.2-2-1.5-.9 1.2zm2.98 1.43l1.5-1.5-1.06-1.06-1.5 1.5 1.06 1.06zm.635-1.36l3 1.5.67-1.34-3-1.5-.67 1.34zm5.365 3.86l1-1-1.06-1.06-1 1 1.06 1.06zm.47-.78h3v-1.5h-3v1.5zm6.658 4.89L16.746 9.803l-1.317.718 5.913 10.84 1.316-.72zM15.254 9.803l-1.912 3.505 1.316.719 1.913-3.506-1.317-.718zM22 20.25h-4v1.5h4v-1.5zM16.746 9.802a.85.85 0 0 0-1.492 0l1.317.718a.65.65 0 0 1-1.142 0l1.317-.718zM16.25 4c0 .69-.56 1.25-1.25 1.25v1.5A2.75 2.75 0 0 0 17.75 4h-1.5zM15 5.25c-.69 0-1.25-.56-1.25-1.25h-1.5A2.75 2.75 0 0 0 15 6.75v-1.5zM13.75 4c0-.69.56-1.25 1.25-1.25v-1.5A2.75 2.75 0 0 0 12.25 4h1.5zM15 2.75c.69 0 1.25.56 1.25 1.25h1.5A2.75 2.75 0 0 0 15 1.25v1.5z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-moon"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M3 12a9 9 0 0 0 17.878 1.483.01.01 0 0 0-.013-.011A8 8 0 0 1 10.528 3.135a.01.01 0 0 0-.01-.013A9 9 0 0 0 3 12z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-play"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.606 17.637l8.822-5.294a.4.4 0 0 0 0-.686L8.606 6.363A.4.4 0 0 0 8 6.706v10.588a.4.4 0 0 0 .606.343z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-partly-cloudy"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 16.995l-.75.011.75-.011zm1.048 2.711l.556-.503-.556.503zm2.604 1.276l.05-.748-.05.748zm.328.017l-.03.75h.03V21zM9.3 21v.75h.013L9.3 21zm.717-.009v-.75.75zm1.152 0v-.75.75zm1.151 0v.75-.75zm2.303 0v-.75.75zm3.062.003l.005-.75-.005.75zm.3.002l-.003.75.004-.75zm1.262-.005l.013.75-.013-.75zm2.66-1.178l-.543-.518.543.517zm.602-.825l-.657-.36.657.36zm.377-.97l-.729-.178.729.177zm.114-.945l.75.003v-.003H23zm-2.286-3.604l-.729.18.088.355.333.15.308-.684zm-10.33-1.821l-.07.747.453.042.247-.383-.63-.406zM7.71 12.946l.04.75.38-.02.208-.32-.628-.41zm-2.626 1.24l-.55-.511.55.51zM4.011 16.67l.748.054-.748-.054zm.003.158l.738.132.019-.107-.012-.108-.745.083zM7.47 12.94l.588.464.93-1.177-.59-.465-.928 1.178zm-.051-4.963l-.589-.465.589.465zm4.373-.515l-.464.588.464-.588zm.35 1.815l.2.723 1.445-.398-.199-.723-1.446.398zM3.766 11.38l.745-.088-.176-1.49-.745.088.176 1.49zm-2.238-1.247l-.744.088.175 1.49.745-.088-.176-1.49zm11.605-5.58l-.465.588 1.178.93.464-.59-1.177-.928zm2.463-.7l.465-.59-1.178-.929-.464.589 1.177.93zM4.51 6.636l.588.464.93-1.177-.59-.465-.928 1.178zm-.7-2.464l-.59-.464-.929 1.177.589.465.93-1.178zm4.58-.364l.087.745 1.49-.176-.088-.745-1.49.176zM9.636 1.57L9.548.827l-1.49.175.089.745 1.49-.176zM3.25 17.006a4.845 4.845 0 0 0 1.242 3.203l1.112-1.006a3.345 3.345 0 0 1-.854-2.22l-1.5.023zm1.242 3.203A4.63 4.63 0 0 0 7.6 21.73l.102-1.496a3.13 3.13 0 0 1-2.099-1.03l-1.112 1.005zM7.6 21.73c.114.008.23.014.35.019l.057-1.5a7.082 7.082 0 0 1-.305-.015L7.6 21.73zm.378.02H9.3l.001-1.5H7.98v1.5zm1.334 0c.365-.007.52-.009.704-.009v-1.5c-.198 0-.365.003-.73.01l.026 1.499zm.704-.009h1.152v-1.5h-1.152v1.5zm1.152 0h1.151v-1.5h-1.15l-.001 1.5zm3.454 0h2.304v-1.5h-2.303v1.5zm2.304 0l.754.003.008-1.5c-.38-.002-.55-.002-.762-.002v1.5zm.754.003l.301.002.008-1.5-.3-.002-.009 1.5zm.301.002c.528.003.9.002 1.278-.005l-.026-1.5c-.362.007-.722.008-1.245.005l-.007 1.5zm1.278-.005a4.509 4.509 0 0 0 3.19-1.411l-1.085-1.035a3.008 3.008 0 0 1-2.131.946l.026 1.5zm3.19-1.411c.28-.294.522-.624.717-.982l-1.315-.72a3.187 3.187 0 0 1-.488.667l1.086 1.035zm.717-.981c.199-.362.35-.75.448-1.155l-1.458-.354a3.25 3.25 0 0 1-.305.788l1.315.72zm.448-1.154c.089-.366.134-.742.135-1.12l-1.5-.004c0 .26-.032.52-.093.769l1.458.355zm.135-1.122c0-1.867-1.08-3.546-2.729-4.288l-.615 1.369c1.098.493 1.844 1.628 1.844 2.92h1.5zm-2.308-3.783c-.712-2.894-3.273-5.04-6.284-5.04v1.5c2.277 0 4.27 1.632 4.827 3.899l1.457-.359zm-6.284-5.04c-2.207 0-4.225 1.156-5.406 2.992l1.262.811c.917-1.425 2.47-2.303 4.144-2.303v-1.5zm-4.705 2.651a3.597 3.597 0 0 0-.334-.015v1.5c.065 0 .13.003.194.009l.14-1.494zm-.334-.015a3.62 3.62 0 0 0-3.036 1.65l1.255.82a2.12 2.12 0 0 1 1.781-.97v-1.5zM7.67 12.197a4.59 4.59 0 0 0-3.136 1.478l1.099 1.02a3.09 3.09 0 0 1 2.116-1l-.079-1.498zm-3.136 1.478a4.815 4.815 0 0 0-1.272 2.942l1.496.107c.054-.763.36-1.474.875-2.029l-1.1-1.02zm-1.272 2.942a1.62 1.62 0 0 0 .005.294l1.491-.166a.12.12 0 0 1 0-.021l-1.496-.107zm.012.079a1.62 1.62 0 0 0-.025.31l1.5-.023c0-.008 0-.016.002-.023l-1.477-.264zM8.4 11.762a2.364 2.364 0 0 1-.391-3.32l-1.178-.93a3.864 3.864 0 0 0 .64 5.428l.929-1.178zm-.391-3.32a2.364 2.364 0 0 1 3.32-.392l.929-1.177a3.864 3.864 0 0 0-5.427.64l1.178.929zm3.32-.392c.412.325.685.758.814 1.227l1.447-.398a3.85 3.85 0 0 0-1.332-2.006l-.93 1.177zM3.59 9.89l-2.062.243.176 1.49 2.062-.243-.176-1.49zm10.72-4.408l1.286-1.63-1.177-.93-1.286 1.63 1.177.93zm-8.87-.023L3.81 4.173l-.93 1.178 1.63 1.286.93-1.178zm4.44-1.826l-.243-2.062-1.49.176.244 2.062 1.49-.176zm2.441 18.108h2.303v-1.5H12.32v1.5z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12h18m-9 9V3"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-reload"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.786 9.2V2.8a.4.4 0 0 0-.64-.32L7.88 5.68a.4.4 0 0 0 0 .64l4.267 3.2a.4.4 0 0 0 .64-.32z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M4 14a8 8 0 1 0 8-8"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12h18M3 18h18M3 6h18"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.679 4.07a3.163 3.163 0 0 0-1.11-.375c-.42-.05-.932.012-1.356.382-.443.385-.85.8-1.212 1.24-.34.414-.394.9-.336 1.304.057.394.224.76.4 1.046.182.299.219.655.042 1.011l-.021.044-.016.046a1.012 1.012 0 0 1-.746.685 2.827 2.827 0 0 0-1.021.457c-.328.245-.632.626-.684 1.16a10.424 10.424 0 0 0-.021 1.733c.039.563.358.967.695 1.227.33.255.722.412 1.06.505.329.09.626.327.79.72.162.393.119.77-.05 1.068-.173.303-.34.692-.393 1.105-.054.422.006.934.377 1.36.385.442.8.848 1.24 1.211.413.34.898.396 1.304.337a2.754 2.754 0 0 0 1.052-.408 1.319 1.319 0 0 1 1.124-.133c.322.141.577.437.676.788.095.336.253.733.508 1.068.258.34.664.673 1.236.715.521.04 1.04.044 1.55.018.57-.029.983-.347 1.25-.683.26-.33.424-.725.521-1.065.093-.325.328-.617.717-.778a1.256 1.256 0 0 1 1.066.072c.306.166.696.326 1.11.375.42.05.932-.012 1.356-.382.443-.385.85-.8 1.212-1.24.34-.413.395-.898.337-1.304a2.753 2.753 0 0 0-.408-1.052 1.319 1.319 0 0 1-.133-1.124c.141-.322.437-.577.788-.676a3.253 3.253 0 0 0 1.068-.508c.34-.258.673-.664.715-1.236.04-.521.044-1.04.018-1.55-.029-.57-.346-.983-.678-1.251a3.185 3.185 0 0 0-1.055-.538 1.255 1.255 0 0 1-.793-.699 1.256 1.256 0 0 1 .072-1.066c.166-.306.326-.696.375-1.11.05-.42-.012-.932-.382-1.356-.385-.443-.8-.85-1.24-1.212-.413-.34-.898-.395-1.304-.337a2.754 2.754 0 0 0-1.052.408 1.32 1.32 0 0 1-1.124.133 1.234 1.234 0 0 1-.676-.788 3.253 3.253 0 0 0-.508-1.068c-.258-.34-.664-.673-1.236-.715-.521-.04-1.04-.044-1.55-.018-.57.029-.983.347-1.25.683a3.13 3.13 0 0 0-.521 1.065 1.193 1.193 0 0 1-.717.778A1.257 1.257 0 0 1 7.68 4.07zm1.318 9.174a3.25 3.25 0 1 1 6.006-2.488 3.25 3.25 0 0 1-6.006 2.488zm1.185-5.632a4.75 4.75 0 1 0 3.636 8.776 4.75 4.75 0 0 0-3.636-8.776z",
    clipRule: "evenodd"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-search"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 8.5,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M17 17l4.657 4.657"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sort-down"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M17.347 9.25H6.653L12 3.139l5.347 6.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 14h14l-7 8-7-8z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sliders"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12h2.724M21 12H10.078M3 18h10.849M21 18h-2.826M3 6h7.632M21 6h-6.014"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 15,
    y: 4,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 2,
    transform: "rotate(90 15 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 18,
    y: 16,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 2,
    transform: "rotate(90 18 16)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 10,
    y: 10,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    rx: 2,
    transform: "rotate(90 10 10)"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-ruler"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M14.314 5.828l2.121 2.122m-4.95.707l2.122 2.121m-4.95.707l2.121 2.122m-4.95.707l2.122 2.121m-4.243 1.414l2.829 2.829a1 1 0 0 0 1.414 0L20.678 7.95a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 0 0-1.414 0L3.707 16.435a1 1 0 0 0 0 1.414z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-right"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M9 21l5-9-5-9"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-settings"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M19.542 8.876a2.085 2.085 0 0 1 .122-1.797c.293-.527.487-1.229.092-1.684a10.252 10.252 0 0 0-1.243-1.214c-.438-.358-1.07-.174-1.544.133a2.152 2.152 0 0 1-1.876.22 2.06 2.06 0 0 1-1.183-1.359c-.16-.591-.51-1.246-1.121-1.292-.53-.04-1.06-.046-1.58-.018-.609.032-.97.669-1.131 1.257a2.017 2.017 0 0 1-1.202 1.336 2.085 2.085 0 0 1-1.797-.122c-.527-.293-1.229-.487-1.684-.092-.447.388-.855.804-1.214 1.243-.358.438-.17 1.068.13 1.547.33.526.402 1.186.09 1.818a1.828 1.828 0 0 1-1.35 1.223c-.55.126-1.13.439-1.185 1.001a10.254 10.254 0 0 0-.02 1.738c.042.601.673.95 1.256 1.103.582.152 1.09.566 1.356 1.207a2.016 2.016 0 0 1-.105 1.813c-.305.52-.504 1.213-.109 1.668.388.447.804.855 1.243 1.215.438.357 1.07.173 1.544-.134a2.152 2.152 0 0 1 1.876-.22c.582.241 1.02.756 1.183 1.359.16.591.51 1.246 1.121 1.292.53.04 1.06.046 1.58.018.609-.032.97-.669 1.131-1.257a2.016 2.016 0 0 1 1.202-1.336 2.085 2.085 0 0 1 1.798.122c.526.293 1.228.487 1.683.092.447-.388.855-.804 1.215-1.243.357-.438.173-1.07-.134-1.544a2.152 2.152 0 0 1-.22-1.876 2.058 2.058 0 0 1 1.359-1.183c.591-.16 1.246-.51 1.292-1.121.04-.53.046-1.06.018-1.58-.032-.609-.671-.981-1.256-1.154a2.084 2.084 0 0 1-1.337-1.179z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M14.922 8.818l-2.646-6.175a.3.3 0 0 0-.552 0L9.078 8.818A.3.3 0 0 1 8.802 9H2.83a.3.3 0 0 0-.192.53l5.185 4.322a.3.3 0 0 1 .08.357l-2.987 6.402a.3.3 0 0 0 .426.384l6.505-3.902a.3.3 0 0 1 .308 0l6.505 3.902a.3.3 0 0 0 .426-.384l-2.987-6.402a.3.3 0 0 1 .08-.357l5.185-4.322a.3.3 0 0 0-.192-.53h-5.973a.3.3 0 0 1-.276-.182z"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sort"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M17.347 9.25H6.653L12 3.139l5.347 6.111zm-10.694 5.5h10.694L12 20.861 6.653 14.75z"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-snow"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M16 2l-4 3-4-3m0 20l4-3 4 3M12 1v7.931M12 23v-7.982M5.34 3.536L5.938 8.5 1.34 10.464m17.32 10l-.598-4.964 4.598-1.964M2.474 6.5l6.601 3.812M21.526 17.5l-6.866-3.964m-13.32 0L5.938 15.5l-.598 4.964m17.32-10L18.062 8.5l.598-4.964M2.474 17.5l6.866-3.964M21.526 6.5l-6.866 3.964"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sort-up"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 10H5l7-8 7 8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M6.653 14.75h10.694L12 20.861 6.653 14.75z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun-filled"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M23 12h-3.5m-15 0H1m18.778-7.778l-2.475 2.475M6.697 17.303l-2.475 2.475M12 1v3.5m0 15V23M4.222 4.222l2.475 2.475m10.606 10.606l2.475 2.475"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-star-filled"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.035 2.348c.364-.849 1.566-.849 1.93 0l2.53 5.902h5.676c.983 0 1.427 1.228.673 1.857l-4.92 4.1 2.841 6.087c.438.939-.604 1.877-1.492 1.345L12 17.875l-6.273 3.764c-.888.532-1.93-.406-1.492-1.345l2.841-6.088-4.92-4.1c-.754-.628-.31-1.856.673-1.856h5.676l2.53-5.902z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-stop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 7,
    y: 6,
    fill: "currentColor",
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 12,
    x: 13,
    y: 6,
    fill: "currentColor",
    rx: 0.6
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sunrise"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.416 5.376L12 3.099 8.584 5.376l.832 1.248 1.834-1.223V8.5h1.5V5.401l1.834 1.223.832-1.248zm-9.25 5.851L3.691 8.752l1.061-1.06 2.475 2.474-1.06 1.061zm10.607-1.06l2.475-2.476 1.06 1.061-2.474 2.475-1.061-1.06zM12 11.75a4.25 4.25 0 0 0-3.035 7.225L8.939 19H7.094a5.75 5.75 0 1 1 9.812 0h-1.845l-.026-.025A4.25 4.25 0 0 0 12 11.75zM7.87 20h.05l-.026.025L7.869 20zm8.21 0h.05l-.024.025-.025-.025zM1 15.25h3.5v1.5H1v-1.5zm18.5 0H23v1.5h-3.5v-1.5z",
    clipRule: "evenodd"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sun"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M23 12h-3.5m-15 0H1m18.778-7.778l-2.475 2.475M6.697 17.303l-2.475 2.475M12 1v3.5m0 15V23M4.222 4.222l2.475 2.475m10.606 10.606l2.475 2.475M17 12a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-table"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M12 21V3M3 9h18M3 15h18M3.9 21h16.2c.497 0 .9-.537.9-1.2V4.2c0-.663-.403-1.2-.9-1.2H3.9c-.497 0-.9.537-.9 1.2v15.6c0 .663.403 1.2.9 1.2z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-temperature"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 18,
    r: 1.25,
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12 17V8m0-5a3 3 0 0 0-3 3v9.354a4 4 0 1 0 6 0V6a3 3 0 0 0-3-3z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-sunset"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 21h18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.25 6.223V3h1.5v3.223L14.584 5l.832 1.248L12 8.525 8.584 6.248 9.416 5l1.834 1.223zm-5.084 5.004L3.691 8.752l1.061-1.06 2.475 2.474-1.06 1.061zm10.607-1.06l2.475-2.476 1.06 1.061-2.474 2.475-1.061-1.06zM12 11.75a4.25 4.25 0 0 0-3.035 7.225L8.939 19H7.094a5.75 5.75 0 1 1 9.812 0h-1.845l-.026-.025A4.25 4.25 0 0 0 12 11.75zM7.87 20h.05l-.026.025L7.869 20zm8.21 0h.05l-.024.025-.025-.025zM1 15.25h3.5v1.5H1v-1.5zm18.5 0H23v1.5h-3.5v-1.5z",
    clipRule: "evenodd"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tide-low"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 18c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1M3 21c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1m-5-11l-4 3-4-3m4 3V3.5"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tide-high"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 18c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1M3 15c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1M3 21c1 0 3-1 3-1s2 1 3 1 3-1 3-1 2 1 3 1 3-1 3-1 2 1 3 1M8 7l4-3 4 3m-4 4V4"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-time-machine"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 12h-.75v.31l.22.22L12 12zm.75 0V7.5h-1.5V12h1.5zm-1.28.53l2 2 1.06-1.06-2-2-1.06 1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12a9 9 0 1 1 2.573 6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.441 10h-4.4a.4.4 0 0 0-.32.64l2.2 2.933a.4.4 0 0 0 .64 0l2.2-2.933a.4.4 0 0 0-.32-.64z"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-umbrella-open"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.04 12l-.747-.06.748.06zm19.92 0l.747-.06-.748.06zm-6.546 10.086l-.53-.53.53.53zm-2.828 0l-.53.53.53-.53zM2.788 12.062C3.221 6.78 7.235 2.75 12 2.75v-1.5c-5.668 0-10.221 4.757-10.707 10.69l1.495.122zM12 2.75c4.765 0 8.78 4.03 9.212 9.312l1.495-.123C22.22 6.007 17.668 1.25 12 1.25v1.5zm9 9.5H3v1.5h18v-1.5zm-19.707-.31c-.084 1.027.758 1.81 1.707 1.81v-1.5a.231.231 0 0 1-.166-.067.15.15 0 0 1-.046-.121l-1.495-.123zm19.919.122a.15.15 0 0 1-.046.121.231.231 0 0 1-.166.067v1.5c.949 0 1.79-.783 1.707-1.81l-1.495.122zM11.25 13v7.672h1.5V13h-1.5zm4.694 9.616l.586-.586-1.06-1.06-.586.585 1.06 1.061zm-3.889 0a2.75 2.75 0 0 0 3.89 0l-1.061-1.06a1.25 1.25 0 0 1-1.768 0l-1.06 1.06zm-.805-1.944c0 .729.29 1.428.805 1.944l1.061-1.06a1.25 1.25 0 0 1-.366-.884h-1.5z"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.126 4.573l-.656-.364.656.364zm-8.3 14.941l.655.365-.656-.365zm18.349 0l.655-.364-.655.364zm-8.3-14.94l.655-.365-.656.364zM20.3 20.25H3.7v1.5h16.6v-1.5zM10.47 4.21l-8.3 14.94 1.311.729 8.3-14.941-1.31-.729zm11.36 14.94l-8.3-14.94-1.311.728 8.3 14.94 1.311-.728zM11.781 4.938a.25.25 0 0 1 .438 0l1.31-.729c-.666-1.2-2.392-1.2-3.059 0l1.311.729zM3.7 20.25a.25.25 0 0 1-.218-.371L2.17 19.15a1.75 1.75 0 0 0 1.53 2.6v-1.5zm16.602 1.5a1.75 1.75 0 0 0 1.53-2.6l-1.312.729a.25.25 0 0 1-.218.371v1.5zM11.25 10v5h1.5v-5h-1.5zm0 7v1.5h1.5V17h-1.5z"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-water"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M1 8c2.75 0 2.75-3 5.5-3S9.25 8 12 8s2.75-3 5.5-3 2.75 3 5.5 3M1 13c2.75 0 2.75-3 5.5-3s2.75 3 5.5 3 2.75-3 5.5-3 2.75 3 5.5 3M1 18c2.75 0 2.75-3 5.5-3s2.75 3 5.5 3 2.75-3 5.5-3 2.75 3 5.5 3"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-up"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 14l9-5 9 5"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wave"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M3 12.5C9 12.5 8.783 5 13.5 5c3.5 0 5 3.5 6 6.5-3.5-1.5-8-1-8 2.5 0 4.5 7 5 10 5"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 9,
    r: 3,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M18 20v-1a6 6 0 0 0-6-6v0a6 6 0 0 0-6 6v1"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-widget"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 8.5,
    x: 2,
    y: 2,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M13.5 17.5a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1V21a1 1 0 0 1-1 1h-6.5a1 1 0 0 1-1-1v-3.5zm0-14.5a1 1 0 0 1 1-1H21a1 1 0 0 1 1 1v9.5a1 1 0 0 1-1 1h-6.5a1 1 0 0 1-1-1V3z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.5,
    height: 8.5,
    x: 2,
    y: 13.5,
    stroke: "currentColor",
    strokeWidth: 1.5,
    rx: 1
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wind"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M18 12H2m7.268-7A2 2 0 1 1 11 8H2m11.5 12a2.5 2.5 0 1 0 2-4H2m15.99-4a3 3 0 1 0-1.801-5.4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpritesheet);
export default __webpack_public_path__ + "static/media/icon-spritesheet.5e553caf.svg";
export { ForwardRef as ReactComponent };